import { useOverlay, InlineButton } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'

export default function MoreMetadataButton({ ...props }) {
  const { t } = useTranslation()
  const overlay = useOverlay()
  const MetadataDialog = props.MetadataDialog
  return (
    <>
      <InlineButton onClick={overlay.handleClick}>{t('more', 'More')}</InlineButton>
      <MetadataDialog {...overlay} {...props} />
    </>
  )
}
